import React from 'react';
import { useState, useEffect } from 'react';
import CustomTittle from '../../components/Elements/customTittle/customTittle';
import pin from '../../assets/images/pin.png';

// npm install mapbox-gl --save instaluje
// npm install --save react-map-gl mapbox-gl
import ApiService from '../../services/ApiService';
import ReactMapGl from 'react-map-gl';

import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
// import { MapContainer, TileLayer, useMap } from 'react-leaflet'
import './maps.css';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'google-maps-react-17';
import MapContainer from "./map.js"
// AIzaSyALqvBtgPaC1VDnsFjvGrXB6xBWtLs0b8A

let long;
let lat;
let closesDistance;
let closesLocation;
let closesId
const Maps = (props) => {
    const apiService = ApiService.getInstance();
    const [markers, setMarkers] = React.useState([]);
    const [locations, setLocation] = useState([]);
    const handleClick = ({ lngLat: [longitude, latitude] }) =>
        setMarkers((markers) => [...markers, { longitude, latitude }]);
    // let locationMap = L.map('map').setView({ lon: 16.982843, lat: 51.110443 }, 4);


    const [isLoad, setIsLoad] = useState(false);
    const [locationsList, setLocationsList] = useState([]);
    const [locationUser, setLocationUser] = useState([]);
    const closesLocationList = [];
    const [permission, setPermission] = useState("")
    const payload = {
        keyController: 'localizations',

        current_LocalizationsID: '0',
    };
    let globalResponse;
    const getCourseForUser = () => {
        apiService.apiPost('CalculateProductForUser', payload, (response) => {
            if (response.success) {
              
                setLocation(response.data.responseBody.body.body);
            }
        });
    };
    let listLoc = []
    useEffect(() => {
        props.setHeader('/  NAJBLIŻSZA SZKOŁA');
        getCourseForUser();
        let currentPosition;
        
    }, []);

   
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
        if (result.state === "granted") {
          setPermission("granted") //git
        } else if (result.state === "prompt") {
            setPermission("prompt") //potrzebna zgoda
        }
        // Don't do anything if the permission was denied.
      });

    useEffect(() => {
  
        if (locations.length != 0) {
            let currentPosition;
            navigator.geolocation.getCurrentPosition((position) => {
                
                if(permission == "granted"){currentPosition = position;
                lat = position.coords.latitude;
                long = position.coords.longitude;}
            });
            for (let i = 0; i < locations.length; i++) {
                // Created an IIFE

                // Delay each iteration by 1 second
                let zipcode = locations[i].zipCode.split('-')[0];
               
               
                //locationUser.postcode
                //locationUser.postcode.split("-")[0]
                //locationUser.postcode.split("-")[0][0]
               
                if (locations[i].zipCode == locationUser.postcode) {
                    closesLocationList.push(locations[i]);
                }
            
                
                if (zipcode == locationUser.postcode?.split("-")[0]) {
                    closesLocationList.push(locations[i]);
                }
                
                
                    if (zipcode[0] == locationUser.postcode?.split("-")[0][0]&&locations[i].zipCode.length != 0) {
                        closesLocationList.push(locations[i]);
                    }
                
             
                if(i == locations.length -1){
                }
            }
            let distance;
            for (let i = 0; i < locations.length; i++) {
                
                (function (i) {
                  
                    setTimeout(async function () {
                        distance = await getLocationByL(
                            locations[i].city + ' ' + locations[i].address,locations[i].localizationsID, locations[i].localizationName +" - " + locations[i].address, locations.length-1 == i
                        );
                        if (i == locations.length - 1) {
                          
                            setIsLoad(true);
                        }
                    }, 1200 * i);
                    
                })(i);
            }
            
        }
    }, [locations]);

    async function getLocationByL(searchVal,id,loc, last) {
        await fetch(
            'https://nominatim.openstreetmap.org/search.php?q=' +
                searchVal +
                '&polygon_geojson=1&format=jsonv2',
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((res) => res.json())
            .then((res) => {
        if(res[0]!= undefined){
     
            listLoc.push({id:id, lat:res[0].lat, lon:res[0].lon, loc:loc, isLast:last })}
            if(last){
                setLocationsList(listLoc)
            }
            });
    }
    async function changeLocation(loc){
        // closesId = id;
       
        await fetch(
            'https://nominatim.openstreetmap.org/search.php?q=' +
            loc.city + ' ' + loc.address +
                '&polygon_geojson=1&format=jsonv2',
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((res) => res.json())
            .then((res) => {
         
               if(res[0] != undefined){
                closesLocation = res[0]
               }
            });
        
    }
    return (
        <>
            <div className="dashboard__content">
                <main>
                    <div className="mapWrapper">
                        <div className="faqContent">
                            <CustomTittle size={'h4'}>SZKOŁY</CustomTittle>
                            <div className="maps">
                            
                            {locationsList.length !=0? <MapContainer
                                  locations={locationsList}
                            />:<div className="awaitPayment1"> <div className="dot1"></div><div className="dot1"></div> <div className="dot1"></div> <div className="dot1"></div> <div className="dot1"></div> </div>}
                               
                            </div>
                            <div className="classInfo">
                               

                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default Maps;

{
    /* <ReactMapGl
initialViewState={{
 longitude: 20.987674,
 latitude: 52.212426,
 zoom: 14
}}
style={{width: 500, height: 300}}
mapStyle="mapbox://styles/mapbox/streets-v9"  
mapboxAccessToken='pk.eyJ1Ijoic2ViYXNzIiwiYSI6ImNsaWo1cDY5cjA0d2czcWtqMWxkenVoOWIifQ.jh0G2hXL8e2bEXOs2foGVA'>
       <Marker longitude={20.987674} latitude={52.212426} anchor="bottom" >
 <img className='pinDot' src={pin} title={location[0].discription.address} />
</Marker>
</ReactMapGl> */
}
